/* eslint-disable react/display-name */
import React from "react"
import { Layout, Header } from "../components/common"
import Helmet from "react-helmet"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import { Stories } from "../templates/posts"

// eslint-disable-next-line arrow-body-style
const Portfolios = () => {
  const data = useStaticQuery(graphql`
    query GetPortfolios {
      portfolios: allGhostPost(
        filter: { tags: { elemMatch: { name: { in: ["Portfolio"] } } } }
      ) {
        edges {
          node {
            localFeatureImage {
              childImageSharp {
                fluid(maxWidth: 1600) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                }
              }
            }
            slug
            id
            title
            tags {
              name
            }
            excerpt
            feature_image
            featured
            html
          }
        }
      }
    }
  `)
  return (
    <>
      <Helmet>
        <title>Tarento - Portfolios | EMPOWERING ENTERPRISES & STARTUPS</title>
        <meta
          name="twitter:url"
          content="https://www.tarento.com/portfolio/"
        ></meta>
        <meta
          property="og:url"
          content="https://www.tarento.com/portfolio/"
        ></meta>
        <meta name="twitter:title" content="Tarento - Portfolios"></meta>
        <meta property="og:title" content="Tarento - Portfolios"></meta>
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_US" />
        <meta
          name="description"
          content="We are privileged and proud of having tens of customers, from the largest companies until small and medium sized segment, across the Nordics and in India."
        ></meta>
        <meta
          name="twitter:description"
          content="We are privileged and proud of having tens of customers, from the largest companies until small and medium sized segment, across the Nordics and in India."
        ></meta>
        <meta
          property="og:description"
          content="We are privileged and proud of having tens of customers, from the largest companies until small and medium sized segment, across the Nordics and in India."
        ></meta>
        <meta
          property="og:image"
          content="https://www.tarento.com/static/cbd6ba47f29435f3f2e0478adbcd2809/c9602/lead.webp"
        ></meta>
        <meta
          name="twitter:image"
          content="https://www.tarento.com/static/cbd6ba47f29435f3f2e0478adbcd2809/c9602/lead.webp"
        ></meta>
        <meta name="twitter:card" content="Portfolio description"></meta>
        <meta name="twitter:site" content="Tarento - Portfolios"></meta>
        <link href="https://www.tarento.com/portfolio/" rel="canonical" />
      </Helmet>
      <Layout>
        <Header />
        <main role="main">
          <section className="layout">
            <div className="container">
              <div className="d-flex justify-content-between titleSection">
                <h1 className=" h4 h2LS d-inline-block align-self-center text-uppercase">
                  Portfolio
                </h1>
              </div>
              <div className="storyCard pt-2">
                <div className="row">
                  {data.portfolios.edges.map(post => (
                    <div className="col-md-6" key={post.node.id}>
                      {post.node.html && (
                        <Link to={post.node.slug + "/"}>
                          <Stories
                            title={post.node.title}
                            description={post.node.excerpt}
                            src={post.node.localFeatureImage.childImageSharp.fluid}
                            style={{ height: "16.2rem" }}
                          ></Stories>
                        </Link>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </main>
      </Layout>
    </>
  )
}

export default Portfolios
